import axios from "axios";

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Default JSON content-type for POST bodies. (Previously set inside the /token fetch, which the
// cutover removed — without it, stringified-JSON posts go out as text/plain and the API returns 415.)
// FormData uploads/downloads still send multipart as before (the browser overrides per-request).
instance.defaults.headers.post["Content-Type"] = "application/json";

export const reqPostCreateCandidate = (payload) => {
  return instance({
    method: "post",
    url: "/api/candidate/CreateCandidate",
    data: payload,
  });
};

export const reqPostUpdateCandidateProfile = (payload) => {
  return instance({
    method: "post",
    url: "/api/candidate/UpdateCandidateProfile",
    data: payload,
  });
};

export const reqPostRetrieveCandidateProfile = (payload) => {
  return instance({
    method: "post",
    url: "/api/candidate/RetrieveCandidateProfile",
    data: payload,
  });
};

export const reqPostRetrieveCandidateApplication = (payload) => {
  return instance({
    method: "post",
    url: "/api/Applications/RetrieveCandidateApplication",
    data: payload,
  });
};

export const reqGetJobUrl = () => {
  return instance({
    url: "/api/common/GetJobUrl",
  });
};

export const reqGetAppProperties = () => {
  return instance({
    url: "/api/applications/Properties",
  });
};

export const reqGetRetrieveJobDetails = (jobPostingID) => {
  return instance({
    url: "/api/applications/RetrieveJobDetails?jobPostingID=" + jobPostingID,
    method: "get",
  });
};

export const reqGetRetrieveApplicationLookupData = (countryID) => {
  return instance({
    method: "get",
    url:
      "/api/Applications/RetrieveApplicationLookupData?countryID=" + countryID,
  });
};

export const reqPostSaveApplication = (payload) => {
  return instance({
    method: "post",
    url: "/api/Applications/SaveApplication",
    data: payload,
  });
};

export const reqPostChangeCandidatePassword = (payload) => {
  return instance({
    method: "post",
    url: "/api/candidate/ChangeCandidatePassword",
    data: payload,
  });
};

export const reqPostSavePasswordResetRequest = (payload) => {
  return instance({
    url: "/api/candidate/SavePasswordResetRequest",
    data: payload,
    method: "post",
  });
};

export const reqPostValidateCandidate = (payload) => {
  return instance({
    method: "post",
    url: "/api/candidate/ValidateCandidate",
    data: payload,
  });
};

export const reqPostLogout = () => {
  return instance({
    method: "post",
    url: "/api/candidate/Logout",
  });
};

export const reqPostUpdateCandidatePassword = (payload) => {
  return instance({
    method: "post",
    url: "/api/Candidate/UpdateCandidatePassword ",
    data: payload,
  });
};

export const reqPostValidateResetPasswordLink = (payload) => {
  return instance({
    url: "/api/candidate/ValidateResetPasswordLink",
    method: "post",
    data: payload,
  });
};

export const reqGetDPCSText = (countryId) => {
  return instance({
    url: "api/common/GetDPCSText?countryID=" + countryId,
    type: "get",
  });
};

export const reqGetRetrieveEmployeeHandbooks = (countryCode) => {
  return instance({
    url: "/api/Onboarding/RetrieveEmployeeHandbooks?countryCode=" + countryCode,
    method: "get",
  });
};

export const reqPostDownloadBase64 = (payload) => {
  return instance({
    url: "/api/blob/DownloadBase64",
    method: "post",
    data: payload,
  });
};

export const reqPutDownloadFile = (payload) => {
  return instance({
    url: "/api/blob/DownloadFile",
    method: "put",
    data: payload,
    responseType: "blob",
  });
};

export const reqPostDownloadFile = (payload) => {
  return instance({
    url: "/api/blob/DownloadFile",
    method: "post",
    data: payload,
    responseType: "blob",
  });
};

export const reqPostSaveOnboardingDocument = (payload) => {
  return instance({
    url: "/api/Onboarding/SaveOnboardingDocument",
    method: "post",
    data: payload,
  });
};

export const reqPostRespondToOffer = (payload) => {
  return instance({
    method: "post",
    url: "/api/TalentPipeline/RespondToOffer",
    data: payload,
  });
};

export const reqGetRetrieveOffers = (candidateID) => {
  return instance({
    url: "/api/talentpipeline/RetrieveOffers?candidateID=" + candidateID,
    method: "get",
  });
};

export const reqGetRetrieveOnboardingLookupData = (JobReqCountryID) => {
  return instance({
    url:
      "/api/Onboarding/RetrieveOnboardingLookupData?countryID=" +
      JobReqCountryID,
    method: "get",
  });
};

export const reqGetListOnboarding = (candidateID) => {
  return instance({
    url: "/api/Onboarding/ListOnboarding?candidateID=" + candidateID,
    method: "get",
  });
};

export const reqGetSaveOnboardingDocumentESignatureAgreement = (payload) => {
  return instance({
    url: "/api/Onboarding/SaveOnboardingDocumentESignatureAgreement",
    method: "post",
    data: payload,
  });
};

export const reqPostSaveOnboarding = (payload) => {
  return instance({
    url: "/api/Onboarding/SaveOnboarding",
    method: "post",
    data: payload,
  });
};

export const reqGetW4Form = (OnboardingID) => {
  return instance({
    url: "/api/Onboarding/GetW4Form?onboardingID=" + OnboardingID,
    method: "get",
  });
};

export const reqPostSaveW4Form = (payload) => {
  return instance({
    url: "/api/Onboarding/SaveW4Form",
    method: "post",
    data: payload,
  });
};

export const reqGetRetrieveAllJobs = () => {
  return instance({
    url: "/api/applications/RetrieveAllJobs",
  });
};

export const reqGetRetrieveAllJobsWithDetails = () => {
  return instance({
    url: "/api/applications/RetrieveAllJobsWithDetails",
  });
};

export const reqGetRetrieveCreateCandidateLookupData = () => {
  return instance({
    method: "get",
    url: "/api/candidate/RetrieveCreateCandidateLookupData",
  });
};

export const reqPostUpdateCandidateDocs = (apiUrl, payload) => {
  return instance({
    url: apiUrl,
    method: "post",
    data: payload,
  });
};

export const reqPostUploadFile = (formData, config) => {
  return instance.post("/api/blob/UploadFile", formData, config);
};

// Cutover (§11.2): the app (Azure) token and the /token endpoint are retired. The candidate session
// lives in the httpOnly `careers_auth` cookie, which the browser sends automatically on same-origin
// requests — so no Authorization header and no request interceptor are needed anymore.

// Candidate session/cookie expired: clear client state and bounce to login (no error toast).
const handleSessionExpired = () => {
  try {
    sessionStorage.removeItem("candidate");
  } catch (e) {
    /* ignore */
  }
  const path = (window.location.pathname || "").toLowerCase();
  if (!path.startsWith("/login")) {
    window.location.href = "/login";
  }
};

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response ? error.response.status : null;
    if (status === 401) {
      // Candidate session expired / not authenticated -> bounce to login (no "Api Error" toast).
      handleSessionExpired();
    }
    return Promise.reject(error);
  }
);

export default instance;
